import { render } from "./course-sidebar.vue?vue&type=template&id=4e0e82d0"
import script from "./course-sidebar.vue?vue&type=script&lang=js"
export * from "./course-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__